import AbstractWidget from "@/models/PlatinumWidget/AbstractWidget";
import PlatinumWidget from "@/models/PlatinumWidget/PlatinumWidget";
import Item from "@/models/PlatinumWidget/HotelList/Item/Item";

export default class HotelList extends AbstractWidget {

    static apiUrl = 'platinum-widget/hotel-list';

    static entity = 'platinumWidgetHotelLists';

    static model_name = 'HotelList';

    static fields() {
        return {
            id: this.number(null).nullable(),
            display_type: this.attr(null),
            created_at: this.attr(null),
            updated_at: this.attr(null),
            widget: this.hasOne(PlatinumWidget, 'widgetable_id'),
            items: this.hasMany(Item, 'platinum_widget_hotel_list_id'),
        }
    }

    Widget() {
        return PlatinumWidget.byWidgetable(this.WidgetTemplate().key, this.id);
    }
}
